import { FC, useEffect, useState } from 'react';
import { Keyboard, Platform, StyleSheet } from 'react-native';
import { Appbar } from 'react-native-paper';
import { TopBarProps } from './types';

export const BottomBar: FC<Omit<TopBarProps, 'title'>> = (
  props: Omit<TopBarProps, 'title'>
) => {
  const [keyboardHeight, setKeyboardHeight] = useState(0);
  const baseBottom = 12;

  useEffect(() => {
    // Only listen to keyboard events on mobile platforms
    if (Platform.OS === 'web') {
      return;
    }

    const showSubscription = Keyboard.addListener(
      Platform.OS === 'ios' ? 'keyboardWillShow' : 'keyboardDidShow',
      (e) => {
        setKeyboardHeight(e.endCoordinates.height);
      }
    );
    const hideSubscription = Keyboard.addListener(
      Platform.OS === 'ios' ? 'keyboardWillHide' : 'keyboardDidHide',
      () => {
        setKeyboardHeight(0);
      }
    );

    return () => {
      showSubscription.remove();
      hideSubscription.remove();
    };
  }, []);

  // Variable height when keyboard is shown/hidden
  const bottomPosition = baseBottom + keyboardHeight;

  return (
    <Appbar.Header
      statusBarHeight={0}
      mode="center-aligned"
      style={[
        props.style
          ? [props.style, styles.footerContainer]
          : styles.footerContainer,
        { bottom: bottomPosition },
      ]}
    >
      {props.left}
      {props.additionalHeaderBlock}
      {props.right}
    </Appbar.Header>
  );
};

const styles = StyleSheet.create({
  footerContainer: {
    position: 'absolute',
    backgroundColor: 'transparent',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    textAlignVertical: 'center',
    width: '100%',
    columnGap: 16,
    elevation: 0,
  }
});
